import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-exitquanping",
  "use": "icon-exitquanping-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-exitquanping\"><path d=\"M235.83183582 687.98750595H141.934659v-104.94390299h281.6915279v265.12143802h-110.46726542v-88.3738131l-165.70089876 165.70089876L70.13093706 853.6884047l165.70089876-165.70089875z m546.81296593 0l165.70089876 165.70089875-77.32708694 77.32708566-165.70089878-165.70089876v88.3738131h-110.4672654V588.56696668h281.69152789v104.94390169h-93.89717553zM235.83183582 312.39880121L92.22438935 168.79135605 164.02811259 91.46427039l149.13080889 149.13080889V152.22126616h110.46726542v265.12143803H141.934659V312.39880121H235.83183582z m557.85969208 0h82.85044938v104.94390298h-281.69152789V152.22126616h110.4672654v93.89717554L859.97188741 91.46427039l77.32708566 77.32708566L793.6915279 312.39880121z\" p-id=\"2358\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/exitquanping.svg
// module id = QH72
// module chunks = 30